import { ApartmentEntry, ApartmentStatus } from '../../types/config';

export const inventoryDataShviro: ApartmentEntry[] = [
  {
    building: 'A1',
    number: 18,
    type: '3B',
    floor: 4,
    rooms: 3,
    area: 79,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'A1_3B_select_floor4',
    nrId: 1,
    floorPlanImage: 'A1_3B',
  },
  {
    building: 'A1',
    number: 21,
    type: '3B',
    floor: 5,
    rooms: 3,
    area: 79,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'A1_3B_select_floor5',
    nrId: 2,
    floorPlanImage: 'A1_3B',
  },
  {
    building: 'A1',
    number: 12,
    type: '5B',
    floor: 3,
    rooms: 5,
    area: 128,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    tourUrl: 'https://my.treedis.com/tour/5b',
    hasVideo: true,
    galleryType: '5b',
    galleryCount: 8,
    id: 'A1_5B_select_floor3',
    nrId: 3,
    floorPlanImage: 'A1_5B',
  },
  {
    building: 'A1',
    number: 15,
    type: '5A',
    floor: 4,
    rooms: 5,
    area: 127,
    balconyArea: 20,
    status: ApartmentStatus.Available,
    liked: false,
    tourUrl: 'https://my.treedis.com/tour/78c5106f',
    hasVideo: true,
    galleryType: 'full',
    galleryCount: 8,
    price: 2880000,
    id: 'A1_5A_select_floor4',
    nrId: 4,
    floorPlanImage: 'A1_5A',
  },
  {
    building: 'A1',
    number: 1,
    type: '5A-G',
    floor: 0,
    rooms: 5,
    area: 127,
    balconyArea: 168,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'A1_5A-G_select_floor0',
    nrId: 5,
    floorPlanImage: 'A1_5A-G',
  },
  {
    building: 'A1',
    number: 2,
    type: '5D-G',
    floor: 0,
    rooms: 5,
    area: 142,
    balconyArea: 67,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'A1_5D-G_select_floor0',
    nrId: 6,
    floorPlanImage: 'A1_5D-G',
  },
  {
    building: 'A1',
    number: 23,
    type: '6P1',
    floor: 6,
    rooms: 6,
    area: 152,
    balconyArea: 19,
    status: ApartmentStatus.Available,
    liked: false,
    tourUrl: 'https://my.treedis.com/tour/fbebc9d9',
    hasVideo: true,
    galleryType: 'full',
    galleryCount: 8,
    id: 'A1_6P1_select_floor6',
    nrId: 7,
    floorPlanImage: 'A1_6P1',
  },
  {
    building: 'A1',
    number: 19,
    type: '5P3',
    floor: 5,
    rooms: 5,
    area: 159,
    balconyArea: 83,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'A1_5P3_select_floor5',
    nrId: 8,
    floorPlanImage: 'A1_5P3',
  },
  {
    building: 'A1',
    number: 22,
    type: '6P3',
    floor: 6,
    rooms: 6,
    area: 169,
    balconyArea: 49,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'A1_6P3_select_floor6',
    nrId: 9,
    floorPlanImage: 'A1_6P3',
  },
  {
    building: 'A1',
    number: 20,
    type: '3A',
    floor: 5,
    rooms: 3,
    area: 77,
    balconyArea: 6,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'A1_3A_select_floor5',
    nrId: 10,
    floorPlanImage: 'A1_3A',
  },
  {
    building: 'A2',
    number: 19,
    type: '3B',
    floor: 5,
    rooms: 3,
    area: 79,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'A2_3B_select_floor5',
    nrId: 11,
    floorPlanImage: 'A2_3B',
  },
  {
    building: 'A2',
    number: 13,
    type: '5B',
    floor: 3,
    rooms: 5,
    area: 128,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    tourUrl: 'https://my.treedis.com/tour/5b',
    hasVideo: true,
    galleryType: '5b',
    galleryCount: 8,
    id: 'A2_5B_select_floor3',
    nrId: 12,
    floorPlanImage: 'A2_5B',
  },
  {
    building: 'A2',
    number: 18,
    type: '5A',
    floor: 4,
    rooms: 5,
    area: 127,
    balconyArea: 20,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'A2_5A_select_floor4',
    nrId: 13,
    floorPlanImage: 'A2_5A',
  },
  {
    building: 'A2',
    number: 2,
    type: '5A-G',
    floor: 0,
    rooms: 5,
    area: 127,
    balconyArea: 93,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'A2_5A-G_select_floor0',
    nrId: 14,
    floorPlanImage: 'A2_5A-G',
  },
  {
    building: 'A2',
    number: 1,
    type: '5D-G',
    floor: 0,
    rooms: 5,
    area: 142,
    balconyArea: 68,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'A2_5D-G_select_floor0',
    nrId: 15,
    floorPlanImage: 'A2_5D-G',
  },
  {
    building: 'A2',
    number: 22,
    type: '6P1',
    floor: 6,
    rooms: 6,
    area: 152,
    balconyArea: 19,
    status: ApartmentStatus.Available,
    liked: false,
    tourUrl: 'https://my.treedis.com/tour/fbebc9d9',
    hasVideo: true,
    galleryType: 'full',
    galleryCount: 8,
    id: 'A2_6P1_select_floor6',
    nrId: 16,
    floorPlanImage: 'A2_6P1',
  },
  {
    building: 'A2',
    number: 21,
    type: '5P3',
    floor: 5,
    rooms: 5,
    area: 159,
    balconyArea: 83,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'A2_5P3_select_floor5',
    nrId: 17,
    floorPlanImage: 'A2_5P3',
  },
  {
    building: 'A2',
    number: 23,
    type: '6P3',
    floor: 6,
    rooms: 6,
    area: 169,
    balconyArea: 49,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'A2_6P3_select_floor6',
    nrId: 18,
    floorPlanImage: 'A2_6P3',
  },
  {
    building: 'A2',
    number: 11,
    type: '3B',
    floor: 3,
    rooms: 3,
    area: 79,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'A2_3B_select_floor3',
    nrId: 19,
    floorPlanImage: 'A2_3B',
  },
  {
    building: 'A2',
    number: 15,
    type: '3B',
    floor: 4,
    rooms: 3,
    area: 79,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'A2_3B_select_floor4',
    nrId: 20,
    floorPlanImage: 'A2_3B',
  },
  {
    building: 'A2',
    number: 20,
    type: '3A',
    floor: 5,
    rooms: 3,
    area: 77,
    balconyArea: 6,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'A2_3A_select_floor5',
    nrId: 21,
    floorPlanImage: 'A2_3A',
  },
  {
    building: 'A2',
    number: 16,
    type: '3A',
    floor: 4,
    rooms: 3,
    area: 77,
    balconyArea: 6,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'A2_3A_select_floor4',
    nrId: 22,
    floorPlanImage: 'A2_3A',
  },
  {
    building: 'B1',
    number: 22,
    type: '3B',
    floor: 5,
    rooms: 3,
    area: 79,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'B1_3B_select_floor5',
    nrId: 23,
    floorPlanImage: 'B1_3B',
  },
  {
    building: 'B1',
    number: 3,
    type: '3A-G',
    floor: 0,
    rooms: 3,
    area: 77,
    balconyArea: 121,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'B1_3A-G_select_floor0',
    nrId: 24,
    floorPlanImage: 'B1_3A-G',
  },
  {
    building: 'B1',
    number: 20,
    type: '5B',
    floor: 5,
    rooms: 5,
    area: 128,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    tourUrl: 'https://my.treedis.com/tour/5b',
    hasVideo: true,
    galleryType: '5b',
    galleryCount: 8,
    id: 'B1_5B_select_floor5',
    nrId: 25,
    floorPlanImage: 'B1_5B',
  },
  {
    building: 'B1',
    number: 16,
    type: '5B',
    floor: 4,
    rooms: 5,
    area: 128,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    tourUrl: 'https://my.treedis.com/tour/5b',
    hasVideo: true,
    galleryType: '5b',
    galleryCount: 8,
    id: 'B1_5B_select_floor4',
    nrId: 26,
    floorPlanImage: 'B1_5B',
  },
  {
    building: 'B1',
    number: 21,
    type: '5A',
    floor: 5,
    rooms: 5,
    area: 127,
    balconyArea: 20,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'B1_5A_select_floor5',
    nrId: 27,
    floorPlanImage: 'B1_5A',
  },
  {
    building: 'B1',
    number: 2,
    type: '5A-G',
    floor: 0,
    rooms: 5,
    area: 126,
    balconyArea: 165,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'B1_5A-G_select_floor0',
    nrId: 28,
    floorPlanImage: 'B1_5A-G',
  },
  {
    building: 'B1',
    number: 25,
    type: '6P1',
    floor: 6,
    rooms: 6,
    area: 152,
    balconyArea: 33,
    status: ApartmentStatus.Available,
    liked: false,
    tourUrl: 'https://my.treedis.com/tour/fbebc9d9',
    hasVideo: true,
    galleryType: 'full',
    galleryCount: 8,
    id: 'B1_6P1_select_floor6',
    nrId: 29,
    floorPlanImage: 'B1_6P1',
  },
  {
    building: 'B1',
    number: 24,
    type: '6P3',
    floor: 6,
    rooms: 6,
    area: 169,
    balconyArea: 99,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'B1_6P3_select_floor6',
    nrId: 30,
    floorPlanImage: 'B1_6P3',
  },
  {
    building: 'B1',
    number: 23,
    type: '3A',
    floor: 5,
    rooms: 3,
    area: 77,
    balconyArea: 6,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B1_3A_select_floor5',
    nrId: 31,
    floorPlanImage: 'B1_3A',
  },
  {
    building: 'B1',
    number: 1,
    type: '5C-G',
    floor: 0,
    rooms: 5,
    area: 130,
    balconyArea: 166,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B1_5C-G_select_floor0',
    nrId: 32,
    floorPlanImage: 'B1_5C-G',
  },
  {
    building: 'B2',
    number: 19,
    type: '3A',
    floor: 5,
    rooms: 3,
    area: 77,
    balconyArea: 6,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'B2_3A_select_floor5',
    nrId: 33,
    floorPlanImage: 'B2_3A',
  },
  {
    building: 'B2',
    number: 16,
    type: '3B',
    floor: 4,
    rooms: 3,
    area: 79,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'B2_3B_select_floor4',
    nrId: 34,
    floorPlanImage: 'B2_3B',
  },
  {
    building: 'B2',
    number: 20,
    type: '3B',
    floor: 5,
    rooms: 3,
    area: 79,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'B2_3B_select_floor5',
    nrId: 35,
    floorPlanImage: 'B2_3B',
  },
  {
    building: 'B2',
    number: 18,
    type: '5B',
    floor: 4,
    rooms: 5,
    area: 128,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    tourUrl: 'https://my.treedis.com/tour/5b',
    hasVideo: true,
    galleryType: '5b',
    galleryCount: 8,
    id: 'B2_5B_select_floor4',
    nrId: 36,
    floorPlanImage: 'B2_5B',
  },
  {
    building: 'B2',
    number: 22,
    type: '5B',
    floor: 5,
    rooms: 5,
    area: 128,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    tourUrl: 'https://my.treedis.com/tour/5b',
    hasVideo: true,
    galleryType: '5b',
    galleryCount: 8,
    id: 'B2_5B_select_floor5',
    nrId: 37,
    floorPlanImage: 'B2_5B',
  },
  {
    building: 'B2',
    number: 21,
    type: '5A',
    floor: 5,
    rooms: 5,
    area: 127,
    balconyArea: 20,
    status: ApartmentStatus.Available,
    liked: false,
    tourUrl: 'https://my.treedis.com/tour/78c5106f',
    hasVideo: true,
    galleryType: 'full',
    galleryCount: 8,
    id: 'B2_5A_select_floor5',
    nrId: 38,
    floorPlanImage: 'B2_5A',
  },
  {
    building: 'B2',
    number: 1,
    type: '4B-G',
    floor: 0,
    rooms: 4,
    area: 122,
    balconyArea: 132,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'B2_4B-G_select_floor0',
    nrId: 39,
    floorPlanImage: 'B2_4B-G',
  },
  {
    building: 'B2',
    number: 2,
    type: '5A-G',
    floor: 0,
    rooms: 5,
    area: 127,
    balconyArea: 93,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'B2_5A-G_select_floor0',
    nrId: 40,
    floorPlanImage: 'B2_5A-G',
  },
  {
    building: 'B2',
    number: 24,
    type: '6P3',
    floor: 6,
    rooms: 6,
    area: 169,
    balconyArea: 99,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'B2_6P3_select_floor6',
    nrId: 41,
    floorPlanImage: 'B2_6P3',
  },
  {
    building: 'B2',
    number: 12,
    type: '3B',
    floor: 3,
    rooms: 3,
    area: 79,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B2_3B_select_floor3',
    nrId: 42,
    floorPlanImage: 'B2_3B',
  },
  {
    building: 'C1',
    number: 20,
    type: '3B',
    floor: 5,
    rooms: 3,
    area: 79,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'C1_3B_select_floor5',
    nrId: 43,
    floorPlanImage: 'C1_3B',
  },
  {
    building: 'C1',
    number: 11,
    type: '5B',
    floor: 3,
    rooms: 5,
    area: 128,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    tourUrl: 'https://my.treedis.com/tour/5b',
    hasVideo: true,
    galleryType: '5b',
    galleryCount: 8,
    id: 'C1_5B_select_floor3',
    nrId: 44,
    floorPlanImage: 'C1_5B',
  },
  {
    building: 'C1',
    number: 16,
    type: '5A',
    floor: 4,
    rooms: 5,
    area: 127,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'C1_5A_select_floor4',
    nrId: 45,
    floorPlanImage: 'C1_5A',
  },
  {
    building: 'C1',
    number: 12,
    type: '5A',
    floor: 3,
    rooms: 5,
    area: 127,
    balconyArea: 20,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C1_5A_select_floor3',
    tourUrl: 'https://my.treedis.com/tour/78c5106f',
    hasVideo: true,
    galleryType: 'full',
    galleryCount: 8,
    nrId: 46,
    floorPlanImage: 'C1_5A',
  },
  {
    building: 'C1',
    number: 2,
    type: '4B-G',
    floor: 0,
    rooms: 4,
    area: 121,
    balconyArea: 73,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'C1_4B-G_select_floor0',
    nrId: 47,
    floorPlanImage: 'C1_4B-G',
  },
  {
    building: 'C1',
    number: 1,
    type: '5A-G',
    floor: 0,
    rooms: 5,
    area: 127,
    balconyArea: 196,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'C1_5A-G_select_floor0',
    nrId: 48,
    floorPlanImage: 'C1_5A-G',
  },
  {
    building: 'C1',
    number: 23,
    type: '6P1',
    floor: 6,
    rooms: 6,
    area: 152,
    balconyArea: 19,
    status: ApartmentStatus.Available,
    liked: false,
    tourUrl: 'https://my.treedis.com/tour/fbebc9d9',
    hasVideo: true,
    galleryType: 'full',
    galleryCount: 8,
    id: 'C1_6P1_select_floor6',
    nrId: 49,
    floorPlanImage: 'C1_6P1',
  },
  {
    building: 'C1',
    number: 19,
    type: '5P3',
    floor: 5,
    rooms: 5,
    area: 159,
    balconyArea: 83,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'C1_5P3_select_floor5',
    nrId: 50,
    floorPlanImage: 'C1_5P3',
  },
  {
    building: 'C1',
    number: 22,
    type: '6P3',
    floor: 6,
    rooms: 6,
    area: 169,
    balconyArea: 49,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'C1_6P3_select_floor6',
    nrId: 51,
    floorPlanImage: 'C1_6P3',
  },
  {
    building: 'C1',
    number: 13,
    type: '3B',
    floor: 3,
    rooms: 3,
    area: 79,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'C1_3B_select_floor3',
    nrId: 52,
    floorPlanImage: 'C1_3B',
  },
  {
    building: 'C1',
    number: 21,
    type: '3A',
    floor: 5,
    rooms: 3,
    area: 77,
    balconyArea: 6,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'C1_3A_select_floor5',
    nrId: 53,
    floorPlanImage: 'C1_3A',
  },
  {
    building: 'C2',
    number: 19,
    type: '3A',
    floor: 5,
    rooms: 3,
    area: 77,
    balconyArea: 6,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'C2_3A_select_floor5',
    nrId: 54,
    floorPlanImage: 'C2_3A',
  },
  {
    building: 'C2',
    number: 12,
    type: '3B',
    floor: 3,
    rooms: 3,
    area: 79,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'C2_3B_select_floor3',
    nrId: 55,
    floorPlanImage: 'C2_3B',
  },
  {
    building: 'C2',
    number: 16,
    type: '3B',
    floor: 4,
    rooms: 3,
    area: 79,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'C2_3B_select_floor4',
    nrId: 56,
    floorPlanImage: 'C2_3B',
  },
  {
    building: 'C2',
    number: 20,
    type: '3B',
    floor: 5,
    rooms: 3,
    area: 79,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'C2_3B_select_floor5',
    nrId: 57,
    floorPlanImage: 'C2_3B',
  },
  {
    building: 'C2',
    number: 14,
    type: '5B',
    floor: 3,
    rooms: 5,
    area: 128,
    balconyArea: 15,
    status: ApartmentStatus.Available,
    liked: false,
    tourUrl: 'https://my.treedis.com/tour/5b',
    hasVideo: true,
    galleryType: '5b',
    galleryCount: 8,
    id: 'C2_5B_select_floor3',
    nrId: 58,
    floorPlanImage: 'C2_5B',
  },
  {
    building: 'C2',
    number: 17,
    type: '5A',
    floor: 4,
    rooms: 5,
    area: 127,
    balconyArea: 20,
    status: ApartmentStatus.Available,
    liked: false,
    id: 'C2_5A_select_floor4',
    tourUrl: 'https://my.treedis.com/tour/78c5106f',
    hasVideo: true,
    galleryType: 'full',
    galleryCount: 8,
    nrId: 59,
    floorPlanImage: 'C2_5A',
  },
  {
    building: 'C2',
    number: 21,
    type: '5P3',
    floor: 5,
    rooms: 5,
    area: 159,
    balconyArea: 83,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'C2_5P3_select_floor5',
    nrId: 60,
    floorPlanImage: 'C2_5P3',
  },
  {
    building: 'C2',
    number: 22,
    type: '6P1',
    floor: 6,
    rooms: 6,
    area: 152,
    balconyArea: 19,
    status: ApartmentStatus.Available,
    liked: false,
    tourUrl: 'https://my.treedis.com/tour/fbebc9d9',
    hasVideo: true,
    galleryType: 'full',
    galleryCount: 8,
    id: 'C2_6P1_select_floor6',
    nrId: 61,
    floorPlanImage: 'C2_6P1',
  },
  {
    building: 'C2',
    number: 1,
    type: '4B-G',
    floor: 0,
    rooms: 4,
    area: 121,
    balconyArea: 73,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'C2_4B-G_select_floor0',
    nrId: 62,
    floorPlanImage: 'C2_4B-G',
  },
  {
    building: 'C2',
    number: 2,
    type: '5A-G',
    floor: 0,
    rooms: 5,
    area: 127,
    balconyArea: 116,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'C2_5A-G_select_floor0',
    nrId: 63,
    floorPlanImage: 'C2_5A-G',
  },
  {
    building: 'C2',
    number: 23,
    type: '6P1',
    floor: 6,
    rooms: 6,
    area: 169,
    balconyArea: 49,
    status: ApartmentStatus.Available,
    liked: false,
    tourUrl: 'https://my.treedis.com/tour/fbebc9d9',
    hasVideo: true,
    galleryType: 'full',
    galleryCount: 8,
    id: 'C2_6P1_select_floor6',
    nrId: 64,
    floorPlanImage: 'C2_6P1',
  },
  {
    building: 'D',
    number: 19,
    type: '3C',
    floor: 4,
    rooms: 3,
    area: 83,
    balconyArea: 8,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'D_3C_select_floor4',
    nrId: 65,
    floorPlanImage: 'D_3C',
  },
  {
    building: 'D',
    number: 27,
    type: '3C',
    floor: 6,
    rooms: 3,
    area: 83,
    balconyArea: 8,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'D_3C_select_floor6',
    nrId: 66,
    floorPlanImage: 'D_3C',
  },
  {
    building: 'D',
    number: 3,
    type: '3C-G',
    floor: 0,
    rooms: 3,
    area: 83,
    balconyArea: 115,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'D_3C-G_select_floor0',
    nrId: 67,
    floorPlanImage: 'D_3C-G',
  },
  {
    building: 'D',
    number: 14,
    type: '5C',
    floor: 3,
    rooms: 5,
    area: 131,
    balconyArea: 17,
    status: ApartmentStatus.Available,
    liked: false,
    price: 3716000,
    tourUrl: 'https://my.treedis.com/tour/6806fca8',
    hasVideo: true,
    galleryType: 'full',
    galleryCount: 8,
    id: 'D_5C_select_floor3',
    nrId: 68,
    floorPlanImage: 'D_5C',
  },
  {
    building: 'D',
    number: 18,
    type: '5C',
    floor: 4,
    rooms: 5,
    area: 131,
    balconyArea: 17,
    status: ApartmentStatus.Available,
    liked: false,
    tourUrl: 'https://my.treedis.com/tour/6806fca8',
    hasVideo: true,
    galleryType: 'full',
    galleryCount: 8,
    id: 'D_5C_select_floor4',
    nrId: 69,
    floorPlanImage: 'D_5C',
  },
  {
    building: 'D',
    number: 1,
    type: '4A-G',
    floor: 0,
    rooms: 4,
    area: 100,
    balconyArea: 133,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'D_4A-G_select_floor0',
    nrId: 70,
    floorPlanImage: 'D_4A-G',
  },
  {
    building: 'D',
    number: 26,
    type: '5C',
    floor: 6,
    rooms: 5,
    area: 131,
    balconyArea: 17,
    status: ApartmentStatus.Available,
    liked: false,
    tourUrl: 'https://my.treedis.com/tour/6806fca8',
    hasVideo: true,
    galleryType: 'full',
    galleryCount: 8,
    id: 'D_5C_select_floor6',
    nrId: 71,
    floorPlanImage: 'D_5C',
  },
  {
    building: 'D',
    number: 28,
    type: '5P1',
    floor: 7,
    rooms: 5,
    area: 140,
    balconyArea: 59,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'D_5P1_select_floor7',
    nrId: 72,
    floorPlanImage: 'D_5P1',
  },
  {
    building: 'D',
    number: 29,
    type: '5P2',
    floor: 7,
    rooms: 5,
    area: 154,
    balconyArea: 111,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'D_5P2_select_floor7',
    nrId: 73,
    floorPlanImage: 'D_5P2',
  },
  {
    building: 'D',
    number: 30,
    type: '6P2',
    floor: 8,
    rooms: 6,
    area: 168,
    balconyArea: 95,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'D_6P2_select_floor8',
    nrId: 74,
    floorPlanImage: 'D_6P2',
  },
  {
    building: 'D',
    number: 2,
    type: '5B-G',
    floor: 0,
    rooms: 5,
    area: 131,
    balconyArea: 207,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'D_5B-G_select_floor0',
    nrId: 75,
    floorPlanImage: 'D_5B-G',
  },
  {
    building: 'D',
    number: 20,
    type: '4A',
    floor: 5,
    rooms: 4,
    area: 99,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'D_4A_select_floor5',
    nrId: 76,
    floorPlanImage: 'D_4A',
  },
  {
    building: 'D',
    number: 12,
    type: '4A',
    floor: 3,
    rooms: 4,
    area: 99,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'D_4A_select_floor3',
    nrId: 77,
    floorPlanImage: 'D_4A',
  },
  {
    building: 'D',
    number: 21,
    type: '4A',
    floor: 5,
    rooms: 4,
    area: 99,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'D_4A_select_floor5',
    nrId: 78,
    floorPlanImage: 'D_4A',
  },
  {
    building: 'D',
    number: 22,
    type: '5C',
    floor: 5,
    rooms: 5,
    area: 131,
    balconyArea: 17,
    status: ApartmentStatus.Available,
    liked: false,
    tourUrl: 'https://my.treedis.com/tour/6806fca8',
    hasVideo: true,
    galleryType: 'full',
    galleryCount: 8,
    id: 'D_5C_select_floor5',
    nrId: 79,
    floorPlanImage: 'D_5C',
  },
  {
    building: 'D',
    number: 23,
    type: '3C',
    floor: 5,
    rooms: 3,
    area: 83,
    balconyArea: 8,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'D_3C_select_floor5',
    nrId: 80,
    floorPlanImage: 'D_3C',
  },
  {
    building: 'D',
    number: 24,
    type: '4A',
    floor: 6,
    rooms: 4,
    area: 99,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'D_4A_select_floor6',
    nrId: 81,
    floorPlanImage: 'D_4A',
  },
  {
    building: 'D',
    number: 25,
    type: '4A',
    floor: 6,
    rooms: 4,
    area: 99,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'D_4A_select_floor6',
    nrId: 82,
    floorPlanImage: 'D_4A',
  },
  {
    building: 'E',
    number: 25,
    type: '3C',
    floor: 6,
    rooms: 3,
    area: 83,
    balconyArea: 8,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'E_3C_select_floor6',
    nrId: 83,
    floorPlanImage: 'E_3C',
  },
  {
    building: 'E',
    number: 2,
    type: '3C-G',
    floor: 0,
    rooms: 3,
    area: 83,
    balconyArea: 114,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'E_3C-G_select_floor0',
    nrId: 84,
    floorPlanImage: 'E_3C-G',
  },
  {
    building: 'E',
    number: 10,
    type: '5C',
    floor: 2,
    rooms: 5,
    area: 131,
    balconyArea: 17,
    status: ApartmentStatus.Available,
    liked: false,
    tourUrl: 'https://my.treedis.com/tour/6806fca8',
    hasVideo: true,
    galleryType: 'full',
    galleryCount: 8,
    id: 'E_5C_select_floor2',
    nrId: 85,
    floorPlanImage: 'E_5C',
  },
  {
    building: 'E',
    number: 14,
    type: '5C',
    floor: 3,
    rooms: 5,
    area: 131,
    balconyArea: 17,
    status: ApartmentStatus.Available,
    liked: false,
    tourUrl: 'https://my.treedis.com/tour/6806fca8',
    hasVideo: true,
    galleryType: 'full',
    galleryCount: 8,
    id: 'E_5C_select_floor3',
    nrId: 86,
    floorPlanImage: 'E_5C',
  },
  {
    building: 'E',
    number: 18,
    type: '5C',
    floor: 4,
    rooms: 5,
    area: 131,
    balconyArea: 17,
    status: ApartmentStatus.Available,
    liked: false,
    tourUrl: 'https://my.treedis.com/tour/6806fca8',
    hasVideo: true,
    galleryType: 'full',
    galleryCount: 8,
    id: 'E_5C_select_floor4',
    nrId: 87,
    floorPlanImage: 'E_5C',
  },
  {
    building: 'E',
    number: 22,
    type: '5C',
    floor: 5,
    rooms: 5,
    area: 131,
    balconyArea: 17,
    status: ApartmentStatus.Available,
    liked: false,
    tourUrl: 'https://my.treedis.com/tour/6806fca8',
    hasVideo: true,
    galleryType: 'full',
    galleryCount: 8,
    id: 'E_5C_select_floor5',
    nrId: 88,
    floorPlanImage: 'E_5C',
  },
  {
    building: 'E',
    number: 26,
    type: '5C',
    floor: 6,
    rooms: 5,
    area: 131,
    balconyArea: 17,
    status: ApartmentStatus.Available,
    liked: false,
    tourUrl: 'https://my.treedis.com/tour/6806fca8',
    hasVideo: true,
    galleryType: 'full',
    galleryCount: 8,
    id: 'E_5C_select_floor6',
    nrId: 89,
    floorPlanImage: 'E_5C',
  },
  {
    building: 'E',
    number: 1,
    type: '4A-G',
    floor: 0,
    rooms: 4,
    area: 100,
    balconyArea: 131,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'E_4A-G_select_floor0',
    nrId: 90,
    floorPlanImage: 'E_4A-G',
  },
  {
    building: 'E',
    number: 28,
    type: '5P2',
    floor: 7,
    rooms: 5,
    area: 154,
    balconyArea: 111,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'E_5P2_select_floor7',
    nrId: 91,
    floorPlanImage: 'E_5P2',
  },
  {
    building: 'E',
    number: 27,
    type: '5P1',
    floor: 7,
    rooms: 5,
    area: 140,
    balconyArea: 59,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'E_5P1_select_floor7',
    nrId: 92,
    floorPlanImage: 'E_5P1',
  },
  {
    building: 'E',
    number: 29,
    type: '6P2',
    floor: 8,
    rooms: 6,
    area: 168,
    balconyArea: 95,
    status: ApartmentStatus.Available,
    galleryType: 'default',
    galleryCount: 8,
    liked: false,
    id: 'E_6P2_select_floor8',
    nrId: 93,
    floorPlanImage: 'E_6P2',
  },
  {
    building: 'E',
    number: 15,
    type: '4A',
    floor: 4,
    rooms: 4,
    area: 99,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'E_4A_select_floor4',
    nrId: 94,
    floorPlanImage: 'E_4A',
  },
  {
    building: 'E',
    number: 19,
    type: '4A',
    floor: 5,
    rooms: 4,
    area: 99,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'E_4A_select_floor5',
    nrId: 95,
    floorPlanImage: 'E_4A',
  },
  {
    building: 'E',
    number: 21,
    type: '3C',
    floor: 5,
    rooms: 3,
    area: 83,
    balconyArea: 8,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'E_3C_select_floor5',
    nrId: 96,
    floorPlanImage: 'E_3C',
  },
  {
    building: 'E',
    number: 16,
    type: '4A',
    floor: 4,
    rooms: 4,
    area: 99,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'E_4A_select_floor4',
    nrId: 97,
    floorPlanImage: 'E_4A',
  },
  {
    building: 'E',
    number: 20,
    type: '4A',
    floor: 5,
    rooms: 4,
    area: 99,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'E_4A_select_floor5',
    nrId: 98,
    floorPlanImage: 'E_4A',
  },
  {
    building: 'E',
    number: 23,
    type: '4A',
    floor: 6,
    rooms: 4,
    area: 99,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'E_4A_select_floor6',
    nrId: 99,
    floorPlanImage: 'E_4A',
  },
  {
    building: 'E',
    number: 24,
    type: '4A',
    floor: 6,
    rooms: 4,
    area: 99,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'E_4A_select_floor6',
    nrId: 100,
    floorPlanImage: 'E_4A',
  },
  {
    building: 'A1',
    number: 3,
    type: 'A-5C',
    floor: 1,
    rooms: 5,
    area: 127,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'A1_A-5C_select_floor1',
    nrId: 101,
    floorPlanImage: 'A1_A-5C',
  },
  {
    building: 'A1',
    number: 4,
    type: 'A-5D',
    floor: 1,
    rooms: 5,
    area: 128,
    balconyArea: 15,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'A1_A-5D_select_floor1',
    nrId: 102,
    floorPlanImage: 'A1_A-5D',
  },
  {
    building: 'A1',
    number: 5,
    type: 'A-3A',
    floor: 1,
    rooms: 3,
    area: 77,
    balconyArea: 6,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'A1_A-3A_select_floor1',
    nrId: 103,
    floorPlanImage: 'A1_A-3A',
  },
  {
    building: 'A1',
    number: 6,
    type: 'A-3B',
    floor: 1,
    rooms: 3,
    area: 79,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'A1_A-3B_select_floor1',
    nrId: 104,
    floorPlanImage: 'A1_A-3B',
  },
  {
    building: 'A1',
    number: 7,
    type: 'A-5C',
    floor: 2,
    rooms: 5,
    area: 127,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'A1_A-5C_select_floor2',
    nrId: 105,
    floorPlanImage: 'A1_A-5C',
  },
  {
    building: 'A1',
    number: 8,
    type: 'A-5D',
    floor: 2,
    rooms: 5,
    area: 128,
    balconyArea: 15,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'A1_A-5D_select_floor2',
    nrId: 106,
    floorPlanImage: 'A1_A-5D',
  },
  {
    building: 'A1',
    number: 9,
    type: 'A-3A',
    floor: 2,
    rooms: 3,
    area: 77,
    balconyArea: 6,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'A1_A-3A_select_floor2',
    nrId: 107,
    floorPlanImage: 'A1_A-3A',
  },
  {
    building: 'A1',
    number: 10,
    type: 'A-3B',
    floor: 2,
    rooms: 3,
    area: 79,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'A1_A-3B_select_floor2',
    nrId: 108,
    floorPlanImage: 'A1_A-3B',
  },
  {
    building: 'A1',
    number: 11,
    type: 'A-5C',
    floor: 3,
    rooms: 5,
    area: 127,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'A1_A-5C_select_floor3',
    nrId: 109,
    floorPlanImage: 'A1_A-5C',
  },
  {
    building: 'A1',
    number: 13,
    type: 'A-3A',
    floor: 3,
    rooms: 3,
    area: 77,
    balconyArea: 6,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'A1_A-3A_select_floor3',
    nrId: 110,
    floorPlanImage: 'A1_A-3A',
  },
  {
    building: 'A1',
    number: 14,
    type: 'A-3B',
    floor: 3,
    rooms: 3,
    area: 79,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'A1_A-3B_select_floor3',
    nrId: 111,
    floorPlanImage: 'A1_A-3B',
  },
  {
    building: 'A1',
    number: 16,
    type: 'A-5E',
    floor: 4,
    rooms: 5,
    area: 168,
    balconyArea: 15,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'A1_A-5E_select_floor4',
    nrId: 112,
    floorPlanImage: 'A1_A-5E',
  },
  {
    building: 'A1',
    number: 17,
    type: 'A-3A',
    floor: 4,
    rooms: 3,
    area: 77,
    balconyArea: 6,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'A1_A-3A_select_floor4',
    nrId: 113,
    floorPlanImage: 'A1_A-3A',
  },
  {
    building: 'A2',
    number: 3,
    type: 'A-3B-M',
    floor: 1,
    rooms: 3,
    area: 79,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'A2_A-3B-M_select_floor1',
    nrId: 114,
    floorPlanImage: 'A2_A-3B-M',
  },
  {
    building: 'A2',
    number: 4,
    type: 'A-3A-M',
    floor: 1,
    rooms: 3,
    area: 77,
    balconyArea: 6,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'A2_A-3A-M_select_floor1',
    nrId: 115,
    floorPlanImage: 'A2_A-3A-M',
  },
  {
    building: 'A2',
    number: 5,
    type: 'A-5D-M',
    floor: 1,
    rooms: 5,
    area: 128,
    balconyArea: 15,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'A2_A-5D-M_select_floor1',
    nrId: 116,
    floorPlanImage: 'A2_A-5D-M',
  },
  {
    building: 'A2',
    number: 6,
    type: 'A-5C-M',
    floor: 1,
    rooms: 5,
    area: 127,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'A2_A-5C-M_select_floor1',
    nrId: 117,
    floorPlanImage: 'A2_A-5C-M',
  },
  {
    building: 'A2',
    number: 7,
    type: 'A-3B-M',
    floor: 2,
    rooms: 3,
    area: 79,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'A2_A-3B-M_select_floor2',
    nrId: 118,
    floorPlanImage: 'A2_A-3B-M',
  },
  {
    building: 'A2',
    number: 8,
    type: 'A-3A-M',
    floor: 2,
    rooms: 3,
    area: 77,
    balconyArea: 6,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'A2_A-3A-M_select_floor2',
    nrId: 119,
    floorPlanImage: 'A2_A-3A-M',
  },
  {
    building: 'A2',
    number: 9,
    type: 'A-5D-M',
    floor: 2,
    rooms: 5,
    area: 128,
    balconyArea: 15,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'A2_A-5D-M_select_floor2',
    nrId: 120,
    floorPlanImage: 'A2_A-5D-M',
  },
  {
    building: 'A2',
    number: 10,
    type: 'A-5C-M',
    floor: 2,
    rooms: 5,
    area: 127,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'A2_A-5C-M_select_floor2',
    nrId: 121,
    floorPlanImage: 'A2_A-5C-M',
  },
  {
    building: 'A2',
    number: 12,
    type: 'A-3A-M',
    floor: 3,
    rooms: 3,
    area: 77,
    balconyArea: 6,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'A2_A-3A-M_select_floor3',
    nrId: 122,
    floorPlanImage: 'A2_A-3A-M',
  },
  {
    building: 'A2',
    number: 14,
    type: 'A-5C-M',
    floor: 3,
    rooms: 5,
    area: 127,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'A2_A-5C-M_select_floor3',
    nrId: 123,
    floorPlanImage: 'A2_A-5C-M',
  },
  {
    building: 'A2',
    number: 17,
    type: 'A-5E-M',
    floor: 4,
    rooms: 5,
    area: 168,
    balconyArea: 15,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'A2_A-5E-M_select_floor4',
    nrId: 124,
    floorPlanImage: 'A2_A-5E-M',
  },
  {
    building: 'B1',
    number: 4,
    type: 'BC-5D',
    floor: 1,
    rooms: 5,
    area: 128,
    balconyArea: 15,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B1_BC-5D_select_floor1',
    nrId: 125,
    floorPlanImage: 'B1_BC-5D',
  },
  {
    building: 'B1',
    number: 5,
    type: 'BC-5C',
    floor: 1,
    rooms: 5,
    area: 127,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B1_BC-5C_select_floor1',
    nrId: 126,
    floorPlanImage: 'B1_BC-5C',
  },
  {
    building: 'B1',
    number: 6,
    type: 'BC-3B',
    floor: 1,
    rooms: 3,
    area: 79,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B1_BC-3B_select_floor1',
    nrId: 127,
    floorPlanImage: 'B1_BC-3B',
  },
  {
    building: 'B1',
    number: 7,
    type: 'BC-3A',
    floor: 1,
    rooms: 3,
    area: 77,
    balconyArea: 6,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B1_BC-3A_select_floor1',
    nrId: 128,
    floorPlanImage: 'B1_BC-3A',
  },
  {
    building: 'B1',
    number: 8,
    type: 'BC-5D',
    floor: 2,
    rooms: 5,
    area: 128,
    balconyArea: 15,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B1_BC-5D_select_floor2',
    nrId: 129,
    floorPlanImage: 'B1_BC-5D',
  },
  {
    building: 'B1',
    number: 9,
    type: 'BC-5C',
    floor: 2,
    rooms: 5,
    area: 127,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B1_BC-5C_select_floor2',
    nrId: 130,
    floorPlanImage: 'B1_BC-5C',
  },
  {
    building: 'B1',
    number: 10,
    type: 'BC-3B',
    floor: 2,
    rooms: 3,
    area: 79,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B1_BC-3B_select_floor2',
    nrId: 131,
    floorPlanImage: 'B1_BC-3B',
  },
  {
    building: 'B1',
    number: 11,
    type: 'BC-3A',
    floor: 2,
    rooms: 3,
    area: 77,
    balconyArea: 6,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B1_BC-3A_select_floor2',
    nrId: 132,
    floorPlanImage: 'B1_BC-3A',
  },
  {
    building: 'B1',
    number: 12,
    type: 'BC-5D',
    floor: 3,
    rooms: 5,
    area: 128,
    balconyArea: 15,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B1_BC-5D_select_floor3',
    nrId: 133,
    floorPlanImage: 'B1_BC-5D',
  },
  {
    building: 'B1',
    number: 13,
    type: 'BC-5C',
    floor: 3,
    rooms: 5,
    area: 127,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B1_BC-5C_select_floor3',
    nrId: 134,
    floorPlanImage: 'B1_BC-5C',
  },
  {
    building: 'B1',
    number: 14,
    type: 'BC-3B',
    floor: 3,
    rooms: 3,
    area: 79,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B1_BC-3B_select_floor3',
    nrId: 135,
    floorPlanImage: 'B1_BC-3B',
  },
  {
    building: 'B1',
    number: 15,
    type: 'BC-3A',
    floor: 3,
    rooms: 3,
    area: 77,
    balconyArea: 6,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B1_BC-3A_select_floor3',
    nrId: 136,
    floorPlanImage: 'B1_BC-3A',
  },
  {
    building: 'B1',
    number: 17,
    type: 'BC-5C',
    floor: 4,
    rooms: 5,
    area: 127,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B1_BC-5C_select_floor4',
    nrId: 137,
    floorPlanImage: 'B1_BC-5C',
  },
  {
    building: 'B1',
    number: 18,
    type: 'BC-3B',
    floor: 4,
    rooms: 3,
    area: 79,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B1_BC-3B_select_floor4',
    nrId: 138,
    floorPlanImage: 'B1_BC-3B',
  },
  {
    building: 'B1',
    number: 19,
    type: 'BC-3A',
    floor: 4,
    rooms: 3,
    area: 77,
    balconyArea: 6,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B1_BC-3A_select_floor4',
    nrId: 139,
    floorPlanImage: 'B1_BC-3A',
  },
  {
    building: 'B2',
    number: 3,
    type: 'BC-3A-M',
    floor: 1,
    rooms: 3,
    area: 77,
    balconyArea: 6,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B2_BC-3A-M_select_floor1',
    nrId: 140,
    floorPlanImage: 'B2_BC-3A-M',
  },
  {
    building: 'B2',
    number: 4,
    type: 'BC-3B-M',
    floor: 1,
    rooms: 3,
    area: 79,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B2_BC-3B-M_select_floor1',
    nrId: 141,
    floorPlanImage: 'B2_BC-3B-M',
  },
  {
    building: 'B2',
    number: 5,
    type: 'BC-5C-M',
    floor: 1,
    rooms: 5,
    area: 127,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B2_BC-5C-M_select_floor1',
    nrId: 142,
    floorPlanImage: 'B2_BC-5C-M',
  },
  {
    building: 'B2',
    number: 6,
    type: 'BC-5D-M',
    floor: 1,
    rooms: 5,
    area: 128,
    balconyArea: 15,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B2_BC-5D-M_select_floor1',
    nrId: 143,
    floorPlanImage: 'B2_BC-5D-M',
  },
  {
    building: 'B2',
    number: 7,
    type: 'BC-3A-M',
    floor: 2,
    rooms: 3,
    area: 77,
    balconyArea: 6,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B2_BC-3A-M_select_floor2',
    nrId: 144,
    floorPlanImage: 'B2_BC-3A-M',
  },
  {
    building: 'B2',
    number: 8,
    type: 'BC-3B-M',
    floor: 2,
    rooms: 3,
    area: 79,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B2_BC-3B-M_select_floor2',
    nrId: 145,
    floorPlanImage: 'B2_BC-3B-M',
  },
  {
    building: 'B2',
    number: 9,
    type: 'BC-5C-M',
    floor: 2,
    rooms: 5,
    area: 127,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B2_BC-5C-M_select_floor2',
    nrId: 146,
    floorPlanImage: 'B2_BC-5C-M',
  },
  {
    building: 'B2',
    number: 10,
    type: 'BC-5D-M',
    floor: 2,
    rooms: 5,
    area: 128,
    balconyArea: 15,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B2_BC-5D-M_select_floor2',
    nrId: 147,
    floorPlanImage: 'B2_BC-5D-M',
  },
  {
    building: 'B2',
    number: 11,
    type: 'BC-3A-M',
    floor: 3,
    rooms: 3,
    area: 77,
    balconyArea: 6,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B2_BC-3A-M_select_floor3',
    nrId: 148,
    floorPlanImage: 'B2_BC-3A-M',
  },
  {
    building: 'B2',
    number: 13,
    type: 'BC-5C-M',
    floor: 3,
    rooms: 5,
    area: 127,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B2_BC-5C-M_select_floor3',
    nrId: 149,
    floorPlanImage: 'B2_BC-5C-M',
  },
  {
    building: 'B2',
    number: 14,
    type: 'BC-5D-M',
    floor: 3,
    rooms: 5,
    area: 128,
    balconyArea: 15,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B2_BC-5D-M_select_floor3',
    nrId: 150,
    floorPlanImage: 'B2_BC-5D-M',
  },
  {
    building: 'B2',
    number: 15,
    type: 'BC-3A-M',
    floor: 4,
    rooms: 3,
    area: 77,
    balconyArea: 6,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B2_BC-3A-M_select_floor4',
    nrId: 151,
    floorPlanImage: 'B2_BC-3A-M',
  },
  {
    building: 'B2',
    number: 17,
    type: 'BC-5C-M',
    floor: 4,
    rooms: 5,
    area: 127,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B2_BC-5C-M_select_floor4',
    nrId: 152,
    floorPlanImage: 'B2_BC-5C-M',
  },
  {
    building: 'B2',
    number: 23,
    type: 'BC-6B-M',
    floor: 6,
    rooms: 6,
    area: 152,
    balconyArea: 33,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'B2_BC-6B-M_select_floor6',
    nrId: 153,
    floorPlanImage: 'B2_BC-6B-M',
  },
  {
    building: 'C1',
    number: 3,
    type: 'BC-5D',
    floor: 1,
    rooms: 5,
    area: 128,
    balconyArea: 15,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'C1_BC-5D_select_floor1',
    nrId: 154,
    floorPlanImage: 'C1_BC-5D',
  },
  {
    building: 'C1',
    number: 4,
    type: 'BC-5C',
    floor: 1,
    rooms: 5,
    area: 127,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'C1_BC-5C_select_floor1',
    nrId: 155,
    floorPlanImage: 'C1_BC-5C',
  },
  {
    building: 'C1',
    number: 5,
    type: 'BC-3B',
    floor: 1,
    rooms: 3,
    area: 79,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'C1_BC-3B_select_floor1',
    nrId: 156,
    floorPlanImage: 'C1_BC-3B',
  },
  {
    building: 'C1',
    number: 6,
    type: 'BC-3A',
    floor: 1,
    rooms: 3,
    area: 77,
    balconyArea: 6,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'C1_BC-3A_select_floor1',
    nrId: 157,
    floorPlanImage: 'C1_BC-3A',
  },
  {
    building: 'C1',
    number: 7,
    type: 'BC-5D',
    floor: 2,
    rooms: 5,
    area: 128,
    balconyArea: 15,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'C1_BC-5D_select_floor2',
    nrId: 158,
    floorPlanImage: 'C1_BC-5D',
  },
  {
    building: 'C1',
    number: 8,
    type: 'BC-5C',
    floor: 2,
    rooms: 5,
    area: 127,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'C1_BC-5C_select_floor2',
    nrId: 159,
    floorPlanImage: 'C1_BC-5C',
  },
  {
    building: 'C1',
    number: 9,
    type: 'BC-3B',
    floor: 2,
    rooms: 3,
    area: 79,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'C1_BC-3B_select_floor2',
    nrId: 160,
    floorPlanImage: 'C1_BC-3B',
  },
  {
    building: 'C1',
    number: 10,
    type: 'BC-3A',
    floor: 2,
    rooms: 3,
    area: 77,
    balconyArea: 6,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'C1_BC-3A_select_floor2',
    nrId: 161,
    floorPlanImage: 'C1_BC-3A',
  },
  {
    building: 'C1',
    number: 14,
    type: 'BC-3A',
    floor: 3,
    rooms: 3,
    area: 77,
    balconyArea: 6,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'C1_BC-3A_select_floor3',
    nrId: 162,
    floorPlanImage: 'C1_BC-3A',
  },
  {
    building: 'C1',
    number: 15,
    type: 'BC-5E',
    floor: 4,
    rooms: 5,
    area: 168,
    balconyArea: 15,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'C1_BC-5E_select_floor4',
    nrId: 163,
    floorPlanImage: 'C1_BC-5E',
  },
  {
    building: 'C1',
    number: 17,
    type: 'BC-3B',
    floor: 4,
    rooms: 3,
    area: 79,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'C1_BC-3B_select_floor4',
    nrId: 164,
    floorPlanImage: 'C1_BC-3B',
  },
  {
    building: 'C1',
    number: 18,
    type: 'BC-3A',
    floor: 4,
    rooms: 3,
    area: 77,
    balconyArea: 6,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'C1_BC-3A_select_floor4',
    nrId: 165,
    floorPlanImage: 'C1_BC-3A',
  },
  {
    building: 'C2',
    number: 3,
    type: 'BC-3A-M',
    floor: 1,
    rooms: 3,
    area: 77,
    balconyArea: 6,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'C2_BC-3A-M_select_floor1',
    nrId: 166,
    floorPlanImage: 'C2_BC-3A-M',
  },
  {
    building: 'C2',
    number: 4,
    type: 'BC-3B-M',
    floor: 1,
    rooms: 3,
    area: 79,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'C2_BC-3B-M_select_floor1',
    nrId: 167,
    floorPlanImage: 'C2_BC-3B-M',
  },
  {
    building: 'C2',
    number: 5,
    type: 'BC-5C-M',
    floor: 1,
    rooms: 5,
    area: 127,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'C2_BC-5C-M_select_floor1',
    nrId: 168,
    floorPlanImage: 'C2_BC-5C-M',
  },
  {
    building: 'C2',
    number: 6,
    type: 'BC-5D-M',
    floor: 1,
    rooms: 5,
    area: 128,
    balconyArea: 15,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'C2_BC-5D-M_select_floor1',
    nrId: 169,
    floorPlanImage: 'C2_BC-5D-M',
  },
  {
    building: 'C2',
    number: 7,
    type: 'BC-3A-M',
    floor: 2,
    rooms: 3,
    area: 77,
    balconyArea: 6,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'C2_BC-3A-M_select_floor2',
    nrId: 170,
    floorPlanImage: 'C2_BC-3A-M',
  },
  {
    building: 'C2',
    number: 8,
    type: 'BC-3B-M',
    floor: 2,
    rooms: 3,
    area: 79,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'C2_BC-3B-M_select_floor2',
    nrId: 171,
    floorPlanImage: 'C2_BC-3B-M',
  },
  {
    building: 'C2',
    number: 9,
    type: 'BC-5C-M',
    floor: 2,
    rooms: 5,
    area: 127,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'C2_BC-5C-M_select_floor2',
    nrId: 172,
    floorPlanImage: 'C2_BC-5C-M',
  },
  {
    building: 'C2',
    number: 10,
    type: 'BC-5D-M',
    floor: 2,
    rooms: 5,
    area: 128,
    balconyArea: 15,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'C2_BC-5D-M_select_floor2',
    nrId: 173,
    floorPlanImage: 'C2_BC-5D-M',
  },
  {
    building: 'C2',
    number: 11,
    type: 'BC-3A-M',
    floor: 3,
    rooms: 3,
    area: 77,
    balconyArea: 6,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'C2_BC-3A-M_select_floor3',
    nrId: 174,
    floorPlanImage: 'C2_BC-3A-M',
  },
  {
    building: 'C2',
    number: 13,
    type: 'BC-5C-M',
    floor: 3,
    rooms: 5,
    area: 127,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'C2_BC-5C-M_select_floor3',
    nrId: 175,
    floorPlanImage: 'C2_BC-5C-M',
  },
  {
    building: 'C2',
    number: 15,
    type: 'BC-3A-M',
    floor: 4,
    rooms: 3,
    area: 77,
    balconyArea: 6,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'C2_BC-3A-M_select_floor4',
    nrId: 176,
    floorPlanImage: 'C2_BC-3A-M',
  },
  {
    building: 'C2',
    number: 18,
    type: 'BC-5E-M',
    floor: 4,
    rooms: 5,
    area: 168,
    balconyArea: 15,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'C2_BC-5E-M_select_floor4',
    nrId: 177,
    floorPlanImage: 'C2_BC-5E-M',
  },
  {
    building: 'D',
    number: 4,
    type: 'DE-4A',
    floor: 1,
    rooms: 4,
    area: 99,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'D_DE-4A_select_floor1',
    nrId: 178,
    floorPlanImage: 'D_DE-4A',
  },
  {
    building: 'D',
    number: 5,
    type: 'DE-4B',
    floor: 1,
    rooms: 4,
    area: 99,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'D_DE-4B_select_floor1',
    nrId: 179,
    floorPlanImage: 'D_DE-4B',
  },
  {
    building: 'D',
    number: 6,
    type: 'DE-5',
    floor: 1,
    rooms: 5,
    area: 131,
    balconyArea: 17,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'D_DE-5_select_floor1',
    nrId: 180,
    floorPlanImage: 'D_DE-5',
  },
  {
    building: 'D',
    number: 7,
    type: 'DE-3',
    floor: 1,
    rooms: 3,
    area: 83,
    balconyArea: 8,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'D_DE-3_select_floor1',
    nrId: 181,
    floorPlanImage: 'D_DE-3',
  },
  {
    building: 'D',
    number: 8,
    type: 'DE-4A',
    floor: 2,
    rooms: 4,
    area: 99,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'D_DE-4A_select_floor2',
    nrId: 182,
    floorPlanImage: 'D_DE-4A',
  },
  {
    building: 'D',
    number: 9,
    type: 'DE-4B',
    floor: 2,
    rooms: 4,
    area: 99,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'D_DE-4B_select_floor2',
    nrId: 183,
    floorPlanImage: 'D_DE-4B',
  },
  {
    building: 'D',
    number: 10,
    type: 'DE-5',
    floor: 2,
    rooms: 5,
    area: 131,
    balconyArea: 17,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'D_DE-5_select_floor2',
    nrId: 184,
    floorPlanImage: 'D_DE-5',
  },
  {
    building: 'D',
    number: 11,
    type: 'DE-3',
    floor: 2,
    rooms: 3,
    area: 83,
    balconyArea: 8,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'D_DE-3_select_floor2',
    nrId: 185,
    floorPlanImage: 'D_DE-3',
  },
  {
    building: 'D',
    number: 13,
    type: 'DE-4B',
    floor: 3,
    rooms: 4,
    area: 99,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'D_DE-4B_select_floor3',
    nrId: 186,
    floorPlanImage: 'D_DE-4B',
  },
  {
    building: 'D',
    number: 15,
    type: 'DE-3',
    floor: 3,
    rooms: 3,
    area: 83,
    balconyArea: 8,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'D_DE-3_select_floor3',
    nrId: 187,
    floorPlanImage: 'D_DE-3',
  },
  {
    building: 'D',
    number: 16,
    type: 'DE-4A',
    floor: 4,
    rooms: 4,
    area: 99,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'D_DE-4A_select_floor4',
    nrId: 188,
    floorPlanImage: 'D_DE-4A',
  },
  {
    building: 'D',
    number: 17,
    type: 'DE-4B',
    floor: 4,
    rooms: 4,
    area: 99,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'D_DE-4B_select_floor4',
    nrId: 189,
    floorPlanImage: 'D_DE-4B',
  },
  {
    building: 'E',
    number: 3,
    type: 'DE-4B-M',
    floor: 1,
    rooms: 4,
    area: 99,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'E_DE-4B-M_select_floor1',
    nrId: 190,
    floorPlanImage: 'E_DE-4B-M',
  },
  {
    building: 'E',
    number: 4,
    type: 'DE-4A-M',
    floor: 1,
    rooms: 4,
    area: 99,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'E_DE-4A-M_select_floor1',
    nrId: 191,
    floorPlanImage: 'E_DE-4A-M',
  },
  {
    building: 'E',
    number: 5,
    type: 'DE-3-M',
    floor: 1,
    rooms: 3,
    area: 83,
    balconyArea: 8,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'E_DE-3-M_select_floor1',
    nrId: 192,
    floorPlanImage: 'E_DE-3-M',
  },
  {
    building: 'E',
    number: 6,
    type: 'DE-5-M',
    floor: 1,
    rooms: 5,
    area: 131,
    balconyArea: 17,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'E_DE-5-M_select_floor1',
    nrId: 193,
    floorPlanImage: 'E_DE-5-M',
  },
  {
    building: 'E',
    number: 7,
    type: 'DE-4B-M',
    floor: 2,
    rooms: 4,
    area: 99,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'E_DE-4B-M_select_floor2',
    nrId: 194,
    floorPlanImage: 'E_DE-4B-M',
  },
  {
    building: 'E',
    number: 8,
    type: 'DE-4A-M',
    floor: 2,
    rooms: 4,
    area: 99,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'E_DE-4A-M_select_floor2',
    nrId: 195,
    floorPlanImage: 'E_DE-4A-M',
  },
  {
    building: 'E',
    number: 9,
    type: 'DE-3-M',
    floor: 2,
    rooms: 3,
    area: 83,
    balconyArea: 8,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'E_DE-3-M_select_floor2',
    nrId: 196,
    floorPlanImage: 'E_DE-3-M',
  },
  {
    building: 'E',
    number: 11,
    type: 'DE-4B-M',
    floor: 3,
    rooms: 4,
    area: 99,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'E_DE-4B-M_select_floor3',
    nrId: 197,
    floorPlanImage: 'E_DE-4B-M',
  },
  {
    building: 'E',
    number: 12,
    type: 'DE-4A-M',
    floor: 3,
    rooms: 4,
    area: 99,
    balconyArea: 12,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'E_DE-4A-M_select_floor3',
    nrId: 198,
    floorPlanImage: 'E_DE-4A-M',
  },
  {
    building: 'E',
    number: 13,
    type: 'DE-3-M',
    floor: 3,
    rooms: 3,
    area: 83,
    balconyArea: 8,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'E_DE-3-M_select_floor3',
    nrId: 199,
    floorPlanImage: 'E_DE-3-M',
  },
  {
    building: 'E',
    number: 17,
    type: 'DE-3-M',
    floor: 4,
    rooms: 3,
    area: 83,
    balconyArea: 8,
    status: ApartmentStatus.Sold,
    liked: false,
    id: 'E_DE-3-M_select_floor4',
    nrId: 200,
    floorPlanImage: 'E_DE-3-M',
  },
];
